import {LinearProgress, Typography} from '@material-ui/core';
import {useState, useEffect, useCallback} from 'react';

const names = [
  'Writing CSPT...',
  'E-mailing Hal...',
  'Adding to SPUD...',
  'Having JISHUKEN...',
  'Removing red...',
  'ANDON?!',
  'Making dial-up noise...',
  'BEEEEP...',
  'BOOOOP...',
  'Making dial-up noise...',
  'Caps Locks Happening...',
];

export default function CustomTableLoading(props) {
  const [text, setText] = useState('Loading...');
  const shuffle = useCallback(() => {
    const index = Math.floor(Math.random() * names.length);

    setText(names[index]);
  }, []);

  useEffect(() => {
    const intervalID = setInterval(shuffle, 200);

    return () => clearInterval(intervalID);
  }, [shuffle]);

  return (
    <>
      <Typography variant="subtitle1">{text}</Typography>
      <LinearProgress />
    </>
  );
}
